import './videoPage.mobile.scss';

import * as React from 'react';
import moment from 'moment';
import * as _ from 'lodash';
import { connect } from 'react-redux';

import { IGlobalStoreState } from '../../../models/store';
import * as StM from '../../../models/store';
import * as ActM from '../../../actions';
import * as SrvM from '../../../services';
import { VideoPlayer } from '../../../components/pages/video';
import EmptyVideoPage from './emptyVideoPage';

const utils = new SrvM.Utils();

interface IVideoPageMobileProps {
    videoLinkId: string;
    club: StM.IClubStoreState;
    session: StM.ISessionStoreState;
    isVideoEnabled: boolean;
    courts: Array<StM.ICourtStoreState>;
    selectedYoutubeId: StM.IYoutubeIdStoreState;

    init: (videoLinkId: string, needSpinner?: boolean) => Promise<StM.ISessionStoreState>;
}


interface IVideoPageMobileState {
    currentClubTime: moment.Moment;
    checkingSessions: boolean;
}

class VideoPageMobile extends React.Component<IVideoPageMobileProps, IVideoPageMobileState> {
    private intervalID: any;
    private sessionCheckIntervalId: any;

    constructor(props: IVideoPageMobileProps) {
        super(props);

        this.state = {
            currentClubTime: utils.getCurrentClubDateTime(props.club),
            checkingSessions: false
        }
    }


    componentDidMount() {
        document.body.classList.add('video');
        this.intervalID = setInterval(() => this.tick(), 1000);
    }

    componentDidUpdate(prevProps: IVideoPageMobileProps) {
        if (
            this.props.videoLinkId !== prevProps.videoLinkId ||
            !_.isEqual(this.props.club, prevProps.club)
        ) {
            this.initializeSession(this.props);
        }
    }

    initializeSession(props: IVideoPageMobileProps) {
        const { videoLinkId, club } = props;
        const isClubValid = club && club.id;

        if (isClubValid) {
            this.props.init(videoLinkId).then(() => {
                this.sessionCheckIntervalId = setInterval(() => this.checkSession(), 30 * 1000);
            });
        }
    }

    componentWillUnmount() {
        clearInterval(this.sessionCheckIntervalId);
        clearInterval(this.intervalID);
    }

    render() {
        const session = this.props.session;
        const club = this.props.club;
        if (!club || !club.id) return null;
        const isShowVideoPage = !!session && utils.hasVideo(session) && session.startDateTime.isBefore(this.state.currentClubTime);

        return (
            <div className="video-page-mobile-wrapper">
                {isShowVideoPage && this.renderVideoPage(session, club)}
                {!isShowVideoPage && <EmptyVideoPage session={session} club={club} />}
            </div>
        )
    };

    private renderVideoPage(session: StM.ISessionStoreState, club: StM.IClubStoreState) {
        const selectedYoutubeId = this.props.selectedYoutubeId;
        const videoId = selectedYoutubeId ? selectedYoutubeId.youtubeId : '';
        return (
            <div className="video-page-mobile page">
                {this.renderHeader(session, club)}
                <VideoPlayer videoId={videoId} />
                <div className="page-content">
                    <h4>Experience one of America's fastest-growing sports.</h4>
                    <p>
                        Squash On Fire is igniting squash in Washington, D.C. with a new world-class high-end squash facility that is open to all.
                        Centrally located, easily accessible, and with programs designed by award-winning coaches, Squash On Fire is designed from the ground up to be unlike any other squash facility in the DC area.
                        We believe the sport of squash should be accessible to everyone.
                        That's why no membership is required to play at our new Squash On Fire facility.
                        Welcome to our new eight-court, high-end facility where everyone who wants to play, can!
                    </p>
                </div>
            </div>
        );
    }

    private renderHeader(session: StM.ISessionStoreState, club: StM.IClubStoreState) {
        const title = utils.getSessionTitle(session);
        const startTimeString = session.startDateTime.format('MMMM D, h:mm A');
        const endTimeString = session.endDateTime.format('h:mm A');
        const timeCourtString = `${startTimeString}-${endTimeString}, ${utils.getSessionCourtsTitle(session)}`;

        return (
            <div className="page-header heading">
                <div className="title">{title}</div>
                <div className="subtitle">{timeCourtString}</div>
                {this.renderPlayers(session)}
                <div className="current-time">Current time: {`${this.state.currentClubTime.format("h:mm A")} ${club.aliasedTimeZone.alias}`}</div>
            </div>
        );
    }

    private renderPlayers(session: StM.ISessionStoreState) {
        if (!session.bookings || !session.bookings.length) return null;
        return (
            <div className="players-wrapper">
                <ul className="players-list">
                    {session.bookings.map((booking, index) => {
                        let player = booking.user.displayName;
                        if (booking.userId === session.ownerId) player += ' (host)';
                        return (
                            <li key={index}>{player}</li>
                        );
                    })}
                </ul>
            </div>
        );
    }

    private tick() {
        const club = this.props.club;
        const currentTime = utils.getCurrentClubDateTime(club);
        this.setState({ ...this.state, currentClubTime: currentTime });
    }

    private checkSession() {
        if (!this.state.checkingSessions) {
            this.setState({ ...this.state, checkingSessions: true }, () => {
                this.props.init(this.props.videoLinkId, false)
                    .then(() => {
                        this.setState({ ...this.state, checkingSessions: false })
                    });
            })
        }
    }
};

function mapStateToProps(state: IGlobalStoreState, ownProps: any) {
    const session = state.pages.video.session;
    const isVideoEnabled = !!session && utils.hasVideo(session) && session.youtubeIds && session.youtubeIds.length > 0;
    return {
        club: state.club
        , videoLinkId: ownProps.match.params.videoLinkId
        , session: session
        , selectedYoutubeId: state.pages.video.selectedYoutubeId
        , courts: state.club.courts
        , isVideoEnabled: isVideoEnabled
    }
}

function mapDispatchToProps(dispatch: any) {
    return {
        init: (videoLinkId: string, needSpinner?: boolean) => { return dispatch(ActM.VideoPageActions.init(videoLinkId, needSpinner)) }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(VideoPageMobile);